import * as React from 'react';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {Box, Button, Checkbox, CircularProgress, IconButton, Link, Typography} from "@mui/material";
import * as turf from "@turf/turf";
import {PieChart} from "react-minimal-pie-chart";
import Map, {Layer, Marker, Popup, Source} from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
// eslint-disable-next-line
import mapboxgl from '!mapbox-gl';
import CircleIcon from "@mui/icons-material/Circle";
import {correctId, correctName, formatPercentage, getColor, getIconById, labelGagnant} from "../../../Utils";
import SquareIcon from "@mui/icons-material/Square";
import {useCallback, useState} from "react";
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';


export default function MapBvs({
                                   resultsByBvsSynthese,
                                   resultsGeomByBvsSynthese,
                                   resultsGeomIrisByBvsSynthese,
                                   resultsByIris,
                                   visible,
                                   filterBv,
                                   setFilterBv,
                                   filterIris,
                                   setFilterIris,
                                   filterStatus,
                                   setFilterStatus,
                                   viewMenu,
                                   selectedBv,
                                   mappingBvArrondissement
                               }) {


    const [centroid, setCentroid] = React.useState(null);
    const [bbox, setBBbox] = React.useState(null);

    const [loading, setLoading] = React.useState(true);

    const [bvs, setBvs] = React.useState(null);
    const [popupInfo, setPopupInfo] = React.useState(null);

    const [banPoints, setBanPoints] = React.useState(null);

    const [filterVictoire, setFilterVictoire] = React.useState(true);
    const [filterListOfIris, setFilterListOfIris] = React.useState(false);
    const [filterListOfBv, setFilterListOfBv] = React.useState(false);

    React.useEffect(() => {

        if (resultsGeomByBvsSynthese && resultsByBvsSynthese) {
            const flaBvsResults = {}
            Object.keys(resultsByBvsSynthese).forEach((d, k) => {
                Object.keys(resultsByBvsSynthese[d]).forEach((k, i) => {
                    flaBvsResults[k] = resultsByBvsSynthese[d][k];

                })
            })

            let bvs = {}
            Object.keys(resultsGeomByBvsSynthese).forEach((d, k) => {
                let key = resultsGeomByBvsSynthese[d].latitude + "_" + resultsGeomByBvsSynthese[d].longitude;
                if (!bvs[key]) {
                    bvs[key] = {
                        latitude: resultsGeomByBvsSynthese[d].latitude,
                        longitude: resultsGeomByBvsSynthese[d].longitude,
                        id: key,
                        bvs: {}
                    }
                }
                if (flaBvsResults[d]) {

                    bvs[key].bvs[d] = {
                        id: d,
                        info: resultsGeomByBvsSynthese[d],
                        results: flaBvsResults[d],
                        color: flaBvsResults[d].color
                    }
                }
            })
            setBvs(bvs);
        }

    }, [resultsGeomByBvsSynthese, resultsByBvsSynthese]);

    React.useEffect(() => {
        if (resultsByIris && mappingBvArrondissement) {
            let bboxShape = {
                "type": "FeatureCollection",
                "features": []
            }
            Object.keys(resultsByIris).forEach((key, k) => {
                Object.keys(resultsByIris[key].bvs).forEach((id, k2) => {
                    const correctedId = correctId(id);
                    let finalCorrectedId = correctedId
                    if (resultsByIris[key].bvs[mappingBvArrondissement[correctedId]]) {
                        finalCorrectedId = mappingBvArrondissement[correctedId];
                    }
                    let bvs = resultsByIris[key].bvs[finalCorrectedId];
                    if (bvs) {
                        let color = resultsByIris[key].bvs[finalCorrectedId].color
                        bvs.bans.forEach((ban, index) => {
                            const longitude = Number(ban.latitude)
                            const latitude = Number(ban.longitude)
                            let insert = true;
                            if (filterIris.includes(key)) {
                                insert = false;
                            }
                            if (filterBv.includes(finalCorrectedId)) {
                                insert = false;
                            }
                            if (filterStatus.includes(resultsByIris[key].bvs[id].color)) {
                                insert = false;
                            }

                            if (insert) {

                                bboxShape.features.push({
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: [longitude, latitude]
                                    },
                                    properties: {
                                        banId: ban.codeBan,
                                        address: ban.libelleBan,
                                        color: color,
                                        irisId: key,
                                        bvid: finalCorrectedId
                                    }
                                })
                            }
                        })
                    }
                })
            })
            setBanPoints(bboxShape);
        }
    }, [resultsByIris, filterIris, filterStatus, filterBv])

    React.useEffect(() => {
        if (resultsGeomIrisByBvsSynthese) {
            let bboxShape = {
                "type": "FeatureCollection",
                "features": []
            };
            Object.keys(resultsGeomIrisByBvsSynthese).forEach((d, k) => {
                let geo = JSON.parse(resultsGeomIrisByBvsSynthese[d].geom);
                bboxShape.features.push({
                    type: "Feature",
                    geometry: geo
                });
            })

            let bbox = turf.bbox(bboxShape);
            let centroid = turf.centroid(bboxShape);
            setCentroid(centroid.geometry.coordinates);
            setBBbox([[bbox[0] - 0.001, bbox[1] - 0.001], [bbox[2] + 0.001, bbox[3] + 0.001]]);
        }

    }, [resultsGeomIrisByBvsSynthese]);

    React.useEffect(() => {
        if (centroid && bbox && resultsByBvsSynthese && resultsGeomByBvsSynthese && resultsGeomIrisByBvsSynthese, bvs) {
            setLoading(false);
        }
    }, [centroid, bbox, resultsByBvsSynthese, resultsGeomByBvsSynthese, resultsGeomIrisByBvsSynthese, bvs])

    function getSelectAll(filterBv) {
        if (filterBv.length === 0) {
            return "Tout désélectionner"
        } else {
            return "Tout sélectionner"
        }
    }

    const [hoverInfo, setHoverInfo] = useState(null);
    const selectedCounty = (hoverInfo && hoverInfo.irisName) || '';


    const onHover = useCallback(event => {
        let found = Object.keys(resultsGeomIrisByBvsSynthese).filter((element) => {
            const shp = JSON.parse(resultsGeomIrisByBvsSynthese[element].geom);
            return turf.booleanPointInPolygon([event.lngLat.lng, event.lngLat.lat], shp);
        });
        if (found.length > 0) {
            const shp = JSON.parse(resultsGeomIrisByBvsSynthese[found[0]].geom);
            let feature = turf.centroid(shp);

            setHoverInfo({
                longitude: feature.geometry.coordinates[0],
                latitude: feature.geometry.coordinates[1],
                irisName: correctName(resultsGeomIrisByBvsSynthese[found[0]].irisName)
            });
        } else {
            setHoverInfo(null);
        }
    }, []);

    if (visible) {
        if (loading) {
            return (<Box sx={{
                width: '100%',
                height: 610,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <CircularProgress/>
            </Box>)
        } else {
            return (
                <Box sx={{width: '100%', height: 610, display: 'flex', flexDirection: 'row'}}>
                    {viewMenu && <Box sx={{width: '20%', height: 610, ml: 5, overflow: 'scroll',}}>
                        <Box>
                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>

                            <Typography> Filtre par status</Typography>
                            <IconButton onClick={() => {
                                setFilterVictoire(!filterVictoire)
                            }}>
                                {filterVictoire && <ArrowDropUpIcon/>}
                                {!filterVictoire && <ArrowDropDownIcon/>}
                            </IconButton>
                            </Box>
                            {filterVictoire && <Box>
                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                <Box sx={{width: 7, height: 25, backgroundColor: "#0fa64e"}}/>
                                <Checkbox
                                    onChange={() => {
                                        if (filterStatus.includes("winner")) {
                                            setFilterStatus(filterStatus.filter((item) => item !== "winner"))
                                        } else {
                                            setFilterStatus([...filterStatus, "winner"])
                                        }
                                    }}
                                    defaultChecked={true}/>
                                <Typography>{labelGagnant.winner}</Typography>
                            </Box>
                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                <Box sx={{width: 7, height: 25, backgroundColor: "#86c14d"}}/>
                                <Checkbox
                                    onChange={() => {
                                        if (filterStatus.includes("winnerJuste")) {
                                            setFilterStatus(filterStatus.filter((item) => item !== "winnerJuste"))
                                        } else {
                                            setFilterStatus([...filterStatus, "winnerJuste"])
                                        }
                                    }}
                                    defaultChecked={true}/> <Typography>{labelGagnant.winnerJuste}</Typography>
                            </Box>
                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                <Box sx={{width: 7, height: 25, backgroundColor: "#eeb408"}}/>
                                <Checkbox
                                    onChange={() => {
                                        if (filterStatus.includes("winnerPeu")) {
                                            setFilterStatus(filterStatus.filter((item) => item !== "winnerPeu"))
                                        } else {
                                            setFilterStatus([...filterStatus, "winnerPeu"])
                                        }
                                    }}
                                    defaultChecked={true}/> <Typography>{labelGagnant.winnerPeu}</Typography>
                            </Box>
                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                <Box sx={{width: 7, height: 25, backgroundColor: "#e70a08"}}/>
                                <Checkbox
                                    onChange={() => {
                                        if (filterStatus.includes("winnerLargement")) {
                                            setFilterStatus(filterStatus.filter((item) => item !== "winnerLargement"))
                                        } else {
                                            setFilterStatus([...filterStatus, "winnerLargement"])
                                        }
                                    }}
                                    defaultChecked={true}/> <Typography>{labelGagnant.winnerLargement}</Typography>
                            </Box>
                            </Box>}
                        </Box>
                        <Box>
                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                <Typography> Filtre par iris</Typography>
                                <IconButton onClick={() => {
                                    setFilterListOfIris(!filterListOfIris)
                                }}>
                                    {filterListOfIris && <ArrowDropUpIcon/>}
                                    {!filterListOfIris && <ArrowDropDownIcon/>}
                                </IconButton>
                            </Box>
                            {filterListOfIris && <Box>
                                <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                    <Button onClick={() => {
                                        if (filterIris.length === 0) {
                                            setFilterIris(Object.keys(resultsByIris).map((id) => {
                                                return id
                                            }))
                                        } else {
                                            setFilterIris([])
                                        }
                                    }}
                                            variant={"outlined"}>
                                        {getSelectAll(filterIris)}
                                    </Button>
                                </Box>
                                {Object.keys(resultsByIris)
                                    .sort((a, b) => {
                                        return resultsGeomIrisByBvsSynthese[a].irisName.localeCompare(resultsGeomIrisByBvsSynthese[b].irisName)
                                    })
                                    .map((id, key) => {

                                        let name = correctName(resultsGeomIrisByBvsSynthese[id].irisName)
                                        let check = !filterIris.includes(id);

                                        return (
                                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}
                                                 key={key}>
                                                <Checkbox
                                                    checked={check}
                                                    onChange={() => {
                                                        if (filterIris.includes(id)) {
                                                            setFilterIris(filterIris.filter((item) => item !== id))
                                                        } else {
                                                            setFilterIris([...filterIris, id])
                                                        }
                                                        check = !check;
                                                    }}/>
                                                <Typography>{name}</Typography>
                                            </Box>

                                        )
                                    })}
                            </Box>}
                        </Box>
                        <Box>
                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                <Typography> Filtre par bv</Typography>
                                <IconButton onClick={() => {
                                    setFilterListOfBv(!filterListOfBv)
                                }}>
                                    {filterListOfBv && <ArrowDropUpIcon/>}
                                    {!filterListOfBv && <ArrowDropDownIcon/>}
                                </IconButton>
                            </Box>
                            {filterListOfBv && <Box>
                                <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                    <Button onClick={() => {
                                        if (filterBv.length === 0) {
                                            setFilterBv(Object.keys(resultsGeomByBvsSynthese).map((id) => {
                                                return correctId(id)
                                            }))
                                        } else {
                                            setFilterBv([])
                                        }
                                    }}
                                            variant={"outlined"}>
                                        {getSelectAll(filterBv)}
                                    </Button>
                                </Box>
                                {Object.keys(resultsGeomByBvsSynthese)
                                    .sort((a, b) => {
                                        return a.localeCompare(b)
                                    })
                                    .map((id, key) => {
                                        let code = id.split("_")[1];
                                        let name = resultsGeomByBvsSynthese[id].name + " (num : " + code + ")";
                                        const correctedId = correctId(id);
                                        let check = !filterBv.includes(correctedId);

                                        return (
                                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}
                                                 key={key}>
                                                <Checkbox
                                                    checked={check}
                                                    onChange={() => {
                                                        if (filterBv.includes(correctedId)) {
                                                            setFilterBv(filterBv.filter((item) => item !== correctedId))
                                                        } else {
                                                            setFilterBv([...filterBv, correctedId])
                                                        }
                                                        check = !check;
                                                    }}

                                                />
                                                <Typography>{name}</Typography>
                                            </Box>
                                        )
                                    })}
                            </Box>}
                        </Box>
                    </Box>}
                    <Box sx={{width: viewMenu ? '80%' : '100%', height: 610}}>
                        <Map
                            style={{
                                width: "100%",
                                height: 600,
                                borderRadius: 25
                            }}
                            initialViewState={{
                                longitude: centroid[0],
                                latitude: centroid[1],
                                bounds: bbox

                            }}
                            mapStyle="mapbox://styles/mapbox/streets-v9"
                            mapboxAccessToken={MAPBOX_TOKEN}
                            interactive={true}
                            preserveDrawingBuffer={true}
                            attributionControl={false}
                            onMouseMove={onHover}
                        >

                            {Object.keys(resultsGeomIrisByBvsSynthese).map((id, key) => {
                                const shp = JSON.parse(resultsGeomIrisByBvsSynthese[id].geom);
                                return (<Source
                                    key={key}
                                    type="geojson"
                                    data={shp}>
                                    <Layer
                                        type={'line'}
                                        paint={{
                                            'line-width': 2,
                                            'line-color': '#000000'
                                        }}
                                    />
                                </Source>)
                            })}

                            {banPoints &&
                                <Source
                                    id="bans"
                                    type="geojson"
                                    data={banPoints}
                                    cluster={false}
                                >
                                    <Layer
                                        id='bans-point'
                                        type='circle'
                                        source={"bans"}
                                        paint={{
                                            'circle-color': [
                                                'match',
                                                ['get', 'color'],
                                                'winner',
                                                '#0fa64e',
                                                'winnerJuste',
                                                '#86c14d',
                                                'winnerPeu',
                                                '#eeb408',
                                                'winnerLargement',
                                                '#dd110e',
                                                '#ccc'
                                            ],
                                            'circle-radius': 4
                                        }}

                                    />
                                </Source>}
                            {Object.keys(bvs).map((id, key) => {
                                let data = []
                                Object.keys(bvs[id].bvs).forEach((idBv) => {
                                    let inserted = true
                                    const bv = bvs[id].bvs[idBv];
                                    if (filterBv.includes(idBv)) {
                                        inserted = false;
                                    }
                                    if (filterStatus.includes("winner") && bv.color === "#0fa64e") {
                                        inserted = false;
                                    }
                                    if (filterStatus.includes("winnerJuste") && bv.color === "#86c14d") {
                                        inserted = false;
                                    }
                                    if (filterStatus.includes("winnerPeu") && bv.color === "#eeb408") {
                                        inserted = false;
                                    }
                                    if (filterStatus.includes("winnerLargement") && bv.color === "#e70a08") {
                                        inserted = false;
                                    }
                                    if (inserted) {
                                        data.push({"title": idBv, "value": 1, "color": bv.color})
                                    }

                                })
                                console.log(bvs[id])
                                let info = {
                                    longitude: bvs[id].longitude,
                                    latitude: bvs[id].latitude,
                                    bvs: bvs[id].bvs
                                }
                                if (data.length > 0) {
                                    return (<Marker
                                        key={`marker-${key}`}
                                        longitude={bvs[id].longitude}
                                        latitude={bvs[id].latitude}
                                        onClick={e => {

                                            e.originalEvent.stopPropagation();
                                            setPopupInfo(info);
                                        }}

                                    >
                                        <PieChart
                                            style={{height: 20, width: 20, border: "2px solid black", borderRadius: 25}}
                                            startAngle={-90}
                                            data={data}

                                        />
                                    </Marker>)
                                }
                            })}
                            {selectedCounty && (
                                <Popup
                                    longitude={hoverInfo.longitude}
                                    latitude={hoverInfo.latitude}
                                    offset={[0, -10]}
                                    closeButton={false}
                                    className="county-info"
                                >
                                    Quartier : {selectedCounty}
                                </Popup>
                            )}
                            {popupInfo && (
                                <Popup
                                    anchor="left"
                                    longitude={Number(popupInfo.longitude)}
                                    latitude={Number(popupInfo.latitude)}
                                    onClose={() => setPopupInfo(null)}


                                >
                                    <Box sx={{width: 400, display: "flex", flexDirection: "column"}}>

                                        {Object.keys(popupInfo.bvs).map(item => {
                                            let line1 = "";


                                            if (popupInfo.bvs[item].info.info) {
                                                line1 = popupInfo.bvs[item].info.info.libelle_reu;
                                            } else {
                                                line1 = popupInfo.bvs[item].info.name;
                                            }
                                            let winner = popupInfo.bvs[item].results.results[0].winner;

                                            return (<Box key={item} sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                mb: 2
                                            }}>
                                                <CircleIcon sx={{color: popupInfo.bvs[item].color}}/>
                                                <Box sx={{display: "flex", flexDirection: "column",}}>
                                                    <Link href={"#" + item}>
                                                        <Typography
                                                            sx={{ml: 1}}>{correctName(line1)}</Typography>
                                                    </Link>
                                                    <Typography>Abstention: {formatPercentage(popupInfo.bvs[item].results.results[0].abstention.perc)}</Typography>
                                                    <Typography>{winner.nomPrenom} ({formatPercentage(winner.perc)})</Typography>
                                                </Box>
                                            </Box>)
                                        })}

                                    </Box>
                                </Popup>
                            )}
                        </Map>
                    </Box>

                </Box>);
        }
    }
}
